import Modal from "@/components/modal/modal.vue";
import ChangeBaselineDateInput from "@/components/changeBaselineDateInput/changeBaselineDateInput.vue";
import { MyGoalService } from "@/services/myGoalsApi";
import { createNamespacedHelpers } from "vuex";
import moment from "moment";

const { mapGetters: userGetters, mapActions: userActions } = createNamespacedHelpers("user");

export default {
	components: {
		Modal,
		ChangeBaselineDateInput,
	},

	data() {
		return {
			availableBaselines: [],
			date: {
				start: null,
				end: null,
			},
		};
	},

	computed: {
		availableStartDates,

		...userGetters(["activeOutlet"]),
	},

	created() {
		this.init();
	},

	methods: {
		init,
		save,

		...userActions(["getMe"]),
	},
};

function availableStartDates() {
	return this.availableBaselines.map((date) => new Date(date.start_date));
}

async function init() {
	this.date = {
		start: this.activeOutlet.baseline.start_date,
		end: this.activeOutlet.baseline.end_date,
	};

	const { data } = await MyGoalService.availableBaselines();
	this.availableBaselines = data.available_baselines;
}

async function save() {
	try {
		await MyGoalService.setBaseline({
			startDate: moment(this.date.start).format("YYYY-MM-DD"),
			endDate: moment(this.date.end).format("YYYY-MM-DD"),
		});

		await this.getMe();

		this.$emit("save");

		this.$ma.trackEvent({
			action: "Change Baseline Dates",
			properties: {
				Value: {
					StartDate: this.date.start,
					EndDate: this.date.end,
				},
				Component: this.$route.name,
			},
		});
	} catch (error) {
		this.$swal({
			text: error.message,
			customClass: "swal_modal",
		});
	}
}
